<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <h1>Encore une dernière chose !</h1>
    <div style="width: 600px; margin: auto;">
      <p style="padding-top: 20px;">
        Bonjour, je suis Marie, ça fait longtemps que je suis ici (dans la troposphère), je pourrai t'aider si tu es
        trop jeune faire le jeu tout·e seul·e. Tu pourras me trouver en bas à droite de ton écran.
      </p>
      <img
        id="cheftaine-petit"
        src="https://cdn.exploreve.fr/content/adaptation_petits/cheftaine_petits.svg"
        alt="cheftaine"
        height="250px"
        style="padding: 20px;"
      />
      <b-form-select v-model="selected" :options="options"></b-form-select>
      <b-button @click="valider()" style="margin: 20px;">Valider</b-button>
      <p v-if="error" style="color: red;">Il faut d'abord selectionner ton âge!</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      error: false,
      selected: null,
      options: [
        { value: null, text: "Choisis ta tranche d'âge ici" },
        { value: "plus11Ans", text: "Plus de 11 ans" },
        { value: "moins11Ans", text: "Moins de 11 ans" }
      ]
    };
  },
  methods: {
    valider: function () {
      if (this.selected) {
        localStorage.setItem("age", this.selected);
        this.$emit("ageChoosed", this.selected);
      } else {
        this.error = true;
      }
    }
  }
};
</script>
